function PageNotFound() {
  return (
    <div
      id="404-not-found"
      className="not-found"
      style={{
        textAlign: 'center', height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column',
      }}
    >
      <header style={{ marginTop: '-7vh' }}>
        <h1 style={{
          width: '100%', lineHeight: '1', fontSize: '128px', color: 'var(--gray-dark)',
        }}
        >
          404
        </h1>
        <p style={{ fontSize: 'var(--font-size-100)', fontWeight: 'var(--font-weight-bold)' }}>Page Not Found</p>
      </header>
      <div>
        <p style={{ fontSize: 'var(--font-size-500)' }}>
          We couldn&rsquo;t find the page you were looking for.
          <br />
          This might be because you don’t have permission or the page has been removed.
        </p>
        <footer style={{ marginTop: 'var(--spacer-3)' }}>
          <ul style={{ display: 'flex', listStyle: 'none', justifyContent: 'center' }}>
            <li style={{ marginRight: 'var(--spacer-3)' }}>
              <a href="https://help.mysidewalk.com" target="_blank" rel="noreferrer">
                Knowledge Center
              </a>
            </li>
            <li style={{ marginRight: 'var(--spacer-3)' }}>
              <a href="mailto:hello@mysidewalk.com" target="_blank" rel="noreferrer">
                Contact Support
              </a>
            </li>
          </ul>
        </footer>
      </div>
    </div>
  );
}

export default PageNotFound;
